import * as API from "../../api"
import * as ActionTypes from "../action-types";
import { REDUX } from '../../../constants'

/**
 * ThirdParty Library
 */
 import {
    message
} from 'antd'

/**
 * Redux Action
 */
import { 
    // get_driver_request,
    get_drivers_request
} from './drivers'

/**
 * Get driver Group
 */

export const get_driver_group_request = (drvgid, uid = null) => dispatch => {
    
    API
    .getDriverGroupByDRVGID(drvgid)
    .then(info => {
        
        try {
            const {
                driverGroup
            } = info

            dispatch(get_driver_group_success(driverGroup, uid))
            // driverGroup && driverGroup.drivers && dispatch(get_driver_request(driverGroup.drivers))


        } catch(err) {
            message.error('Error in getting driver groups. Refresh page?')
        }

    })
}

const get_driver_group_success = (driverGroup, uid = null) => {
    return {
        type: ActionTypes.GET_DRIVER_GROUP,
        driverGroup,
        uid
    };
}

/**
 * Get driver Groups
 */

//  export const get_driver_groups_request = (drvgids, uid = null) => dispatch => {

//     let drvgidBatch = []

//     drvgids.map((drvgid, index) => {

//         drvgidBatch.push(drvgid)

//         if( 
//             (index+1) % REDUX.REDUX_DEVICE_GROUP_BATCH_GET_SIZE === 0
//             ||
//             index+1 === drvgids.length
//         ) {
//             dispatch(batch_get_driver_groups_request(drvgidBatch, uid))
//             drvgidBatch = []
//         }

//         return null
//     })
//  }

// Ubah jadi async function
export const get_driver_groups_request = (drvgids, uid = null) => async dispatch => {
    
    // 1. Bikin batch-batch dulu
    const batches = [];
    let currentBatch = [];
    
    drvgids.forEach((drvgid, index) => {
        currentBatch.push(drvgid);
        
        if (
            (index + 1) % REDUX.REDUX_DEVICE_GROUP_BATCH_GET_SIZE === 0 ||
            index + 1 === drvgids.length
        ) {
            batches.push([...currentBatch]); // Simpan batch
            currentBatch = [];
        }
    });
    
    // 2. Proses sequential: 1 batch selesai → lanjut batch berikutnya
    for (let i = 0; i < batches.length; i++) {
        const batch = batches[i];
        
        // TUNGGU sampe batch ini selesai
        await dispatch(batch_get_driver_groups_request(batch, uid));
        
        // Jeda opsional
        await delay(500); // 500ms antar batch
    }
};

// Helper delay
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Batch Get driver Groups
 */
 export const batch_get_driver_groups_request = (drvgids, uid = null) => dispatch => {

    API
    .getDriverGroupBatch(drvgids)
    .then(info => {
        
        try {
            const {
                driverGroups
            } = info

            dispatch(batch_get_driver_groups_success(driverGroups, uid))

            driverGroups 
            && driverGroups.length 
            && dispatch(
                get_drivers_request(
                    driverGroups.reduce((acc, cur) => [...acc, ...cur.drivers], [])
                )
            )


        } catch(err) {
            console.log(`Error`, err)
            message.error('Error in batch getting driver groups. Refresh page?')
        }

    })
}

const batch_get_driver_groups_success = (driverGroups, uid = null) => {
    return {
        type: ActionTypes.GET_DRIVER_GROUPS,
        driverGroups,
        uid
    };
}

